//react
import React, { Component } from 'react';
import ReactGA from 'react-ga';

//components
import LanguageTabs from '../languageTabs/languageTabs';

//data
import dataSiteMap from '../../siteMap.json';
import dataTranslations from './translations.json';

//assets
import './videoPlayer.css';

class VideoPlayer extends Component {
	constructor() {
		super();

		this.state = {
			currentChapter: 0,
			currentTime: 0,
			languageIndex: 0,
			playing: false,
		};

		this.playVideo = this.playVideo.bind(this);
		this.videoPlay = this.videoPlay.bind(this);
		this.videoPlaying = this.videoPlaying.bind(this);
		this.videoSetTime = this.videoSetTime.bind(this);
		this.getCurrentChapter = this.getCurrentChapter.bind(this);
		this.chapterSkip = this.chapterSkip.bind(this);
		this.getChapterList = this.getChapterList.bind(this);
		this.changeLanguage = this.changeLanguage.bind(this);
	}

	componentWillReceiveProps() {
		this.setState({
			currentChapter: 0,
			currentTime: 0,
			languageIndex: 0,
			playing: false,
		});

		this.refs.video.pause();
		this.refs.video.currentTime = 0;

		this.refs.progressBar.style.transform = 'translateX(-100%)';
	}

	playVideo() {
		this.refs.video.play();
	}

	videoPlay() {
		this.setState({
			playing: true,
		});

		ReactGA.event({
			category: 'video',
			action: 'play',
			label: 'usingNyxoid',
		});
	}

	videoPlaying() {
		const currentChapter = this.getCurrentChapter(this.refs.video.currentTime);
		const percentPlayed = 100 - ((this.refs.video.currentTime / this.refs.video.duration) * 100);
		this.refs.progressBar.style.transform = 'translateX(-' + percentPlayed + '%)';

		if (this.state.currentChapter !== currentChapter) {
			ReactGA.event({
				category: 'video',
				action: 'chapterView',
				label: 'usingNyxoid',
				value: currentChapter,
			});
		}

		this.setState({
			currentChapter: this.getCurrentChapter(this.refs.video.currentTime),
			currentTime: this.refs.video.currentTime,
		});
	}

	videoSetTime(time) {
		this.refs.video.currentTime = time;
		this.refs.video.play();
	}

	getCurrentChapter(time) {
		let currentChapter = 0;

		for (const [index, chapter] of this.getChapterList().entries()) {
			if (chapter.time <= time) {
				currentChapter = index + 1;
			}
		}
		return currentChapter;
	}

	chapterSkip(skipBack) {
		let indexRequest = this.state.currentChapter; //next chapter index

		if (skipBack) {
			indexRequest = indexRequest - 2; //previous chapter index
		}

		const chapterList = this.getChapterList();

		if (chapterList[indexRequest]) {
			this.refs.video.currentTime = chapterList[indexRequest].time;
			this.refs.video.play();
		}
	}

	trackDownload() {
		ReactGA.event({
			category: 'video',
			action: 'download',
			label: 'usingNyxoid',
		});
	}

	getChapterList() {
		const culture = this.props.culture;
		const cultureFallback = 'uk'; //UK set as the default culture

		let chapterList = [];

		if (dataTranslations[culture][this.state.languageIndex].chapters) {
			chapterList = dataTranslations[culture][this.state.languageIndex].chapters;
		} else {
			chapterList = dataTranslations[cultureFallback][0].chapters;
		}

		return chapterList;
	}

	changeLanguage(languageIndex) {
		this.setState({
			currentChapter: 0,
			currentTime: 0,
			languageIndex: languageIndex,
			playing: false,
		});

		this.refs.video.pause();
		this.refs.video.currentTime = 0;

		this.refs.progressBar.style.transform = 'translateX(-100%)';
	}

	render() {
		const culture = this.props.culture;
		const cultureFallback = 'uk'; //UK set as the default culture
		const currentChapter = this.state.currentChapter;

		let videoPath = '';
		let videoLength = 0;

		if (dataTranslations[culture][this.state.languageIndex].videoPath) {
			videoPath = dataTranslations[culture][this.state.languageIndex].videoPath;
		} else {
			videoPath = dataTranslations[cultureFallback][0].videoPath;
		}

		if (dataTranslations[culture][this.state.languageIndex].videoLength) {
			videoLength = dataTranslations[culture][this.state.languageIndex].videoLength;
		} else {
			videoLength = dataTranslations[cultureFallback][0].videoLength;
		}

		let videoStyle = 'video-player__video';
		let videoProgressBarStyle = 'video-player__progress__bar';

		if (this.state.playing) {
			videoStyle += ' video-player__video--playing';
			videoProgressBarStyle += ' video-player__progress__bar--active'
		}

		const chapterList = this.getChapterList();

		const chapterButtons = chapterList.map((chapter, index) => {
			let buttonClass = 'video-player__progress__chapter hwa';
			const chapterNumber = index + 1;

			if (chapterNumber < currentChapter) {
				buttonClass += ' video-player__progress__chapter--previous';
			} else if (chapterNumber === currentChapter) {
				buttonClass += ' video-player__progress__chapter--current';
			}

			return (
				<button className={buttonClass} key={index} onClick={() => {this.videoSetTime(chapter.time)}} style={{left: (chapter.time / videoLength) * 100 + '%'}}>{index + 1}</button>
			);
		});

		let chapterStyle = 'video-player__chapter';
		let currentChapterNumber = '';
		let __htmlCurrentChapterTitle = '';

		if (chapterList[currentChapter - 1]) {
			chapterStyle += ' video-player__chapter--active';
			currentChapterNumber = currentChapter + '.';
			__htmlCurrentChapterTitle = chapterList[currentChapter - 1].__htmlTitle;
		}

		let __htmlPreviousChapterTitle = '';
		let __htmlNextChapterTitle = '';

		if (chapterList[currentChapter - 2]) {
			__htmlPreviousChapterTitle = currentChapter - 1 + '. ' + chapterList[currentChapter - 2].__htmlTitle;
		}

		if (chapterList[currentChapter]) {
			__htmlNextChapterTitle = currentChapter + 1 + '. ' + chapterList[currentChapter].__htmlTitle;
		}

		let previousButtonClass = 'video-player__controls__button video-player__controls__button--previous hwa';
		let nextButtonClass = 'video-player__controls__button video-player__controls__button--next hwa';

		if (__htmlPreviousChapterTitle === '') {
			previousButtonClass += ' video-player__controls__button--disabled';
		}

		if (__htmlNextChapterTitle === '') {
			nextButtonClass += ' video-player__controls__button--disabled';
		}

		let controlLabelDownload = dataTranslations[cultureFallback][0].controls.download;
		let controlLabelPrevious = dataTranslations[cultureFallback][0].controls.previous;
		let controlLabelNext = dataTranslations[cultureFallback][0].controls.next;

		if (dataTranslations[culture][this.state.languageIndex].controls) {
			controlLabelDownload = dataTranslations[culture][this.state.languageIndex].controls.download;
			controlLabelPrevious = dataTranslations[culture][this.state.languageIndex].controls.previous;
			controlLabelNext = dataTranslations[culture][this.state.languageIndex].controls.next;
		}

		return (
			<div className="video-player">
				<LanguageTabs changeLanguage={this.changeLanguage} culture={culture} languageIndex={this.state.languageIndex} translations={dataTranslations[culture]} />
				<div className={videoStyle}>
					<video className="video-player__video__player" controls controlsList="nodownload" onPlay={this.videoPlay} onTimeUpdate={this.videoPlaying} playsInline ref="video" src={process.env.PUBLIC_URL + videoPath} />
					<button className="video-player__video__poster" onClick={() => this.playVideo()}>
						<div className="video-player__video__poster__icon"></div>
					</button>
				</div>
				<div className="video-player__details">
					<a className="video-player__download hwa" download href={process.env.PUBLIC_URL + videoPath} hrefLang={dataSiteMap[culture].cultureCode} onClick={this.trackDownload} title={controlLabelDownload}>{controlLabelDownload}</a>
					<div className={chapterStyle}>
						<span className="video-player__chapter__number">{currentChapterNumber}</span>
						<span className="video-player__chapter__title" dangerouslySetInnerHTML={{__html: __htmlCurrentChapterTitle}} />
					</div>
				</div>
				<div className="video-player__progress">
					<div className={videoProgressBarStyle} ref="progressBar"></div>
					{chapterButtons}
				</div>
				<div className="video-player__controls">
					<div className="video-player__controls__row">
						<div className="video-player__controls__column">
							<button className={previousButtonClass} onClick={() => this.chapterSkip(true)}>
								<div className="video-player__controls__button__label">{controlLabelPrevious}</div>
								<div className="video-player__controls__button__chapter" dangerouslySetInnerHTML={{__html: __htmlPreviousChapterTitle}}></div>
							</button>
						</div>
						<div className="video-player__controls__column">
							<button className={nextButtonClass} onClick={() => this.chapterSkip(false)}>
								<div className="video-player__controls__button__label">{controlLabelNext}</div>
								<div className="video-player__controls__button__chapter" dangerouslySetInnerHTML={{__html: __htmlNextChapterTitle}} />
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default VideoPlayer;



// WEBPACK FOOTER //
// ./src/components/videoPlayer/videoPlayer.js